import { Col, Container, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';
import Modal from '../../../../../components/Modal';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useGetCalendarURLMutation, useSaveCalendarURLMutation } from '../../../../../features/authentication/classesApiSlice';
import CustomToast from '../../../../../components/Toast';
import ConfirmationModal from '../../../../../components/ConfirmationPopUp';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarDays } from '@fortawesome/free-solid-svg-icons';

const CalendarLink = ({ isOpen, onClose, classId }) => {
  const [getCalendarURL] = useGetCalendarURLMutation();
  const [saveCalendarURL] = useSaveCalendarURLMutation();

  const [calendarLink, setCalendarLink] = useState('');
  const [isConfirmationVisible, setIsConfirmationVisible] = useState(false);

  useEffect(() => {
    getCalendarLink();
  }, [isOpen]);

  const getCalendarLink = async () => {
    var response = await getCalendarURL(classId).unwrap();
    setCalendarLink(response.calendarUrl);
  };    

  const handleSaveCalendarUrl = async () => {
    const options =
        {
          id: classId,
          url: calendarLink
        };
    var response = await saveCalendarURL(options);
    if (response.error) {
      CustomToast(response.error.data.error, 'error');
      return;
    }
    CustomToast('Google Calendar URL Saved Successfully.', 'success');
    onClose();
  };

  return (
    <>
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        contentWidth={'45%'}
        titleName={'Save Google Calendar Link'}
      >
        <Container>
          <Row>
            <Col>
              <div className='d-flex'>
                <label className='mb-3'>Google Calendar Link</label> &nbsp;&nbsp;
                {calendarLink?.length>0 && <OverlayTrigger
                  key="openLink"
                  placement="top"
                  overlay={<Tooltip className="custom-tooltip">
                 Open Calendar
                  </Tooltip>}>
                  <a href={calendarLink} target="_blank" rel="noopener noreferrer" className='text-success'>
                    <FontAwesomeIcon icon={faCalendarDays} />
                  </a>
                </OverlayTrigger>
                }
              </div>
              <input
                type="text"
                className={'form-control'}
                value={calendarLink}
                onChange={(e) => { setCalendarLink(e.target.value); }}
              />
            </Col>
          </Row>
          <Row className='justify-content-end mt-4'>
            <Col className='col-5'>
              <div className='d-flex justify-content-end'>
                <button className='btn btn-castleGray flex-grow-1 mr-2'
                  onClick={() => onClose(false)}>
                    Cancel
                </button>
                <button
                  className='btn btn-castleRed flex-grow-1'
                  onClick={() => calendarLink.length > 0 ? handleSaveCalendarUrl() : setIsConfirmationVisible(true)}>
                     Save&nbsp;
                </button>
              </div>
            </Col>
          </Row>
        </Container>
      </Modal>

      <ConfirmationModal
        key={'confirmation'}
        isOpen={isConfirmationVisible}
        onClose={() => setIsConfirmationVisible(false)}
        onSave={() => handleSaveCalendarUrl()}
        contentWidth={'655px'}
        buttonPosition={'center'}
        content={'No URL entered, any saved calendar Url will be removed. Is this OK?'}
        titleName={'Confirm'}
        cancelButton={'No'}
        confirmButton={'Yes'}
      />
    </>
  );
};

CalendarLink.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  classId: PropTypes.number.isRequired
};
export default CalendarLink;